module.exports = __webpack_public_path__ + "img/idex.d330e65b.png";